import axios from 'axios'
import { FrankfurterRate } from '../models/mapper'

const ECB_URL = 'https://data-api.ecb.europa.eu/service/data/EXR/'
const FRANKFURTER_RATES_URL = 'https://api.frankfurter.dev/v2/rates'
const SOURCE_TIMEOUT_MS = 5000

export const exchangeRateHttp = axios.create({ timeout: SOURCE_TIMEOUT_MS })

export async function fetchCurrencyExchangeData(seriesKey: string, opts?: { signal?: AbortSignal }) {
  return await exchangeRateHttp.get<string>(`${ECB_URL}${seriesKey}`, {
    params: {
      lastNObservations: 1,
      format: 'csvdata',
      detail: 'dataonly',
    },
    signal: opts?.signal,
  })
}

export async function fetchFrankfurterExchangeData(currency: string, opts?: { signal?: AbortSignal }) {
  return await exchangeRateHttp.get<FrankfurterRate[]>(FRANKFURTER_RATES_URL, {
    params: {
      base: 'EUR',
      quotes: currency,
    },
    signal: opts?.signal,
  })
}
